import * as EnumSG from "./mf-sg-enums";
import * as Enums from "./../../../../../../framework/enum.shared";
import * as MfEnum from "./../../singapore/base/mf-sg-enums";

import {
  ProductID,
  UserRoles,
} from "./../../../../../../framework/const.shared";
import { TransType, UserType } from "./../../../../../../framework/enum.shared";

import { ExceptionManager } from "./../../../../../../framework/utils/exception-manager";
import { GUID } from "./../../../../../../framework/domain-entity/guid";
import { Global } from "../../../../../../shared/global";
import { Identity } from "../../../../../../shared/user/identity";
import { MortgageFireSingaporeClientCreateQuestionSection } from "./questions/mf-sg-client-create-question-section";
import { MortgageFireSingaporeMasterQuestionSection } from "./questions/mf-sg-master-question-section";
import { MortgageFireSingaporePremiumSummaryQuestionSection } from "./questions/mf-sg-premium-summary-question-section";
import { MortgageFireSingaporeProposalLocation } from "./mf-sg-proposal-location";
import { Proposal } from "../../../../base/proposal.model";
import { ProposalEntity } from "./../../../../base/proposal-entity.model";
import { ProposalPackage } from "./../../../../base/proposal-package-model";
import { QuestionEntity } from "./../../../../base/question-entity.model";
import { common } from "./../../../../../../framework/utils/common";
import { mortgageFireSingaporeHelper } from "./../utils/mf-sg-helper";
import { proposalEntityFactory } from "./../../../../factory/proposal-entity.factory";
import { proposalHelper } from "./../../../../utils/proposal.helper";
import { IdentityRolesService } from "../../../../../../services/identity-roles.service";
import { MasterDataService } from "src/app/services/master-data.service";

export class MortgageFireSingaporeProposal extends ProposalPackage<MortgageFireSingaporeProposalLocation> {
  /** cmwanx: 2017-11-7
   * Mortgage Fire was originally designed to cater multiple locations.
   *
   * Later JK decided it will always be single location.
   * Although front end is now only capturing for single location,
   * but [Proposal] class still remains its multi location design to extends from [ProposalPackage]
   */

  qsMaster!: MortgageFireSingaporeMasterQuestionSection;
  qsPremiumSummary!: MortgageFireSingaporePremiumSummaryQuestionSection;
  qsClientCreate!: MortgageFireSingaporeClientCreateQuestionSection;
  productType: MfEnum.MortgageFireSgProduct;

  messageId!: number;
  printType?: string;
  printCorrespondence?: string;
  isReprint?: boolean;
  isSummary?: boolean;
  isManual?: boolean;
  isPasswordProtected?: boolean;
  IsCancellationAdjustment!: boolean;

  /** ProposalEntity that last used for refreshing questions */
  refreshedProposalEntity!: ProposalEntity;
  // TODO: other sections question implementation

  /**
   * productID
   * proposalEntity <= will be passing in while proposalApi retrieved object from back end
   */
  constructor(
    productId: GUID,
    public override identityRolesService: IdentityRolesService,
    public masterDataService: MasterDataService
  ) {
    super(productId, identityRolesService);

    this.productType = mortgageFireSingaporeHelper.readProductType(
      this.productId
    )!;

    this.initialize();
  }

  initialize() {
    // initialize sections
    this.qsMaster = new MortgageFireSingaporeMasterQuestionSection(
      this.masterDataService
    );
    this.qsPremiumSummary =
      new MortgageFireSingaporePremiumSummaryQuestionSection(
        this.masterDataService
      );
    this.qsClientCreate = new MortgageFireSingaporeClientCreateQuestionSection(
      this.masterDataService
    );

    this.children = [];
  }

  refreshQuestionsReadOnly(proposalEntity: ProposalEntity) {
    const questions = this.extractQuestionArray();

    questions.forEach((question) => {
      const q = proposalEntity.getQuestion(question.key);
      if (q && common.isDefined(q)) {
        if (
          this.transType === Enums.TransType.CAN ||
          this.endorsementType === Enums.EndorsementType.LoanRedemption ||
          this.endorsementType === Enums.EndorsementType.ChangeOfPOI ||
          this.endorsementType === Enums.EndorsementType.ChangeOfSumInsured ||
          this.endorsementType ===
            Enums.EndorsementType.ChangeOfCorrespondenceAddress ||
          this.endorsementType === Enums.EndorsementType.ChangeOfClientInfo ||
          this.endorsementType ===
            Enums.EndorsementType.ChangeOfAdditionalInsured ||
          this.endorsementType === Enums.EndorsementType.GstAdjustment ||
          this.endorsementType === Enums.EndorsementType.ChangeOfPlanType
        ) {
          question.readOnly = true;
        } else {
          question.readOnly = q.readOnly;
        }
      }
    });
  }

  refreshQuestionsReadOnlyForcbsOps(proposalEntity: ProposalEntity) {
    const isIBGProducts =
      this.productType === EnumSG.MortgageFireSgProduct.IBGMAC ||
      this.productType === EnumSG.MortgageFireSgProduct.IBGMF;

    const isIBGOPS =
      this.identityRolesService.IsCbsOps &&
      isIBGProducts &&
      this.transType === Enums.TransType.END &&
      this.endorsementType === Enums.EndorsementType.GeneralEndorsement &&
      this.proposalStatus === Enums.ProposalStatus.Incomplete;

    const isCBGOPS =
      this.identityRolesService.IsCbsOps &&
      this.transType === Enums.TransType.END &&
      this.proposalStatus === Enums.ProposalStatus.Incomplete;

    if (isIBGOPS || isCBGOPS) {
      const questions = this.extractQuestionArray();
      questions.forEach((question) => {
        const q = proposalEntity.getQuestion(question.key);
        if (common.isDefined(q)) {
          question.readOnly = true;
        }
      });
    }
  }

  refreshCustomQuestionsReadOnly = (proposalEntity: ProposalEntity) => {
    this.qsMaster.qs_risk_insuredAddress1!.readOnly = true;
    this.qsMaster.qs_risk_insuredAddress2!.readOnly = true;
    this.qsMaster.qs_risk_insuredPostalCode!.readOnly = true;
    this.qsMaster.qs_risk_insuredCity!.readOnly = true;
    this.qsMaster.qs_risk_insuredCountry!.readOnly = true;
    this.qsMaster.qs_master_poi_endDate!.readOnly = true;
    // this.qsMaster.qs_master_insuredNo.readOnly = true;
    this.qsMaster.qs_fire_householdContents!.readOnly = true;
    this.qsMaster.qs_master_insuredAddress!.readOnly = true;
    this.qsMaster.qs_risk_uploadRiskAddress!.readOnly = true;
    this.qsMaster.qs_master_insuredCountry!.readOnly = true;
    this.qsPremiumSummary.qs_master_brokerCommission.required = false;
    this.qsMaster.qs_master_insuredAddress1!.readOnly = true;
    this.qsMaster.qs_master_insuredAddress2!.readOnly = true;
    this.qsMaster.qs_master_insuredPostalCode!.readOnly = true;
    this.qsMaster.qs_master_insuredCity!.readOnly = true;
    this.qsMaster.qs_master_insuredState!.readOnly = true;
    this.qsMaster.qs_master_insuredCountry!.readOnly = true;
    if (this.transType === Enums.TransType.END) {
      this.qsMaster.qs_master_masterPolicyNumber!.readOnly = true;
      this.qsMaster.qs_master_planType!.readOnly = true;
      this.qsMaster.qs_master_premiumPayment!.readOnly = true;
      this.qsMaster.qs_master_discountCode!.readOnly = true;
    }

    switch (this.productType) {
      case EnumSG.MortgageFireSgProduct.HDB:
      case EnumSG.MortgageFireSgProduct.CTHDB:
        this.qsMaster.qs_fire_notes!.required = false;
        // HDB don't have Fire Replacement Value Question. So setting min value as 0.
        this.qsMaster.qs_fire_replacement!.minValue = 0;
        this.qsMaster.qs_fire_building!.minValue = 1;
        this.qsMaster.qs_master_insuredNo!.readOnly = true;
        break;
      case EnumSG.MortgageFireSgProduct.MIP:
      case EnumSG.MortgageFireSgProduct.PTE:
      case EnumSG.MortgageFireSgProduct.IBGMF:
      case EnumSG.MortgageFireSgProduct.IBGMAC:
      case EnumSG.MortgageFireSgProduct.CTMFPTE:
      case EnumSG.MortgageFireSgProduct.CTMFCONDO:
        // this.qsMaster.qs_fire_occupied.answer = true;
        //  this.qsMaster.qs_fire_notes.required = false;
        if (
          this.productType === EnumSG.MortgageFireSgProduct.IBGMF ||
          this.productType === EnumSG.MortgageFireSgProduct.IBGMAC
        ) {
          this.qsMaster.qs_master_insuredAddress1!.required = true;
          this.qsMaster.qs_master_insuredNo!.maxLength = 15;
          //  this.qsMaster.qs_master_insuredPostalCode.required = true;
          // this.qsMaster.qs_master_insuredCity.required = true;
          // this.qsMaster.qs_master_insuredState.readOnly = true;
        } else {
          this.qsMaster.qs_master_insuredNo!.readOnly = true;
        }
        if (this.productType === EnumSG.MortgageFireSgProduct.PTE) {
          this.qsMaster.qs_fire_notes!.required = false;
        }
        if (
          (this.productType === EnumSG.MortgageFireSgProduct.MIP ||
            this.productType === EnumSG.MortgageFireSgProduct.PTE) &&
          ((this.proposalStatus === Enums.ProposalStatus.Incomplete &&
            (this.identityRolesService.isMaker || this.isUnderwriter)) ||
            (this.proposalStatus === Enums.ProposalStatus.Referred &&
              this.isUnderwriter &&
              !this.identityRolesService.getIdentity().role
                .isOperationUnderwriter))
        ) {
          // if is Renewal
          if (
            this.transType !== Enums.TransType.REN &&
            !this.identityRolesService.isBroker
          ) {
            this.qsMaster.qs_fire_occupied!.readOnly = false;
          }

          if (
            this.qsMaster.qs_master_manualUnderwritting!.answer === "False" ||
            this.qsMaster.qs_master_manualUnderwritting!.answer === false
          ) {
            // if is Renewal
            if (
              this.transType !== Enums.TransType.REN &&
              !this.identityRolesService.isBroker
            ) {
              this.qsMaster.qs_master_manualUnderwritting!.readOnly = false;
            }
          }
        }

        // set min value for Fire Replacement Value and Building Questions
        this.qsMaster.qs_fire_replacement!.minValue = 1;
        this.qsMaster.qs_fire_building!.minValue = 1;
        break;
      default:
        break;
    }

    // assign value for CBG product only
    switch (this.productType) {
      case EnumSG.MortgageFireSgProduct.HDB:
      case EnumSG.MortgageFireSgProduct.MIP:
      case EnumSG.MortgageFireSgProduct.PTE:
        if (this.endorsementType != Enums.EndorsementType.ChangeOfPlanType) {
          this.qsMaster.qs_master_planType!.readOnly = true;
        }

        break;
      case EnumSG.MortgageFireSgProduct.IBGMF:
        this.qsMaster.qs_master_miRate!.readOnly = true;
        break;
      default:
        break;
    }

    if (
      (this.transType === Enums.TransType.CAN ||
        this.endorsementType === Enums.EndorsementType.LoanRedemption ||
        this.endorsementType === Enums.EndorsementType.ChangeOfPOI ||
        this.endorsementType ===
          Enums.EndorsementType.ChangeOfCorrespondenceAddress ||
        this.endorsementType === Enums.EndorsementType.ChangeOfClientInfo ||
        this.endorsementType === Enums.EndorsementType.ChangeOfSumInsured ||
        this.endorsementType ===
          Enums.EndorsementType.ChangeOfAdditionalInsured ||
        this.endorsementType === Enums.EndorsementType.GstAdjustment) &&
      ((this.proposalStatus === Enums.ProposalStatus.Incomplete &&
        (this.identityRolesService.isMaker || this.isUnderwriter)) ||
        (this.proposalStatus === Enums.ProposalStatus.Referred &&
          !this.identityRolesService.getIdentity().role.isOperationUnderwriter))
    ) {
      this.qsMaster.qs_master_effectiveDate!.readOnly = false;
      this.qsMaster.qs_master_endorse_endorsementReason!.readOnly = false;
      this.qsMaster.qs_master_cancellation_adjustmentAmount!.readOnly = false;
      this.qsMaster.qs_fire_occupied!.readOnly = true;
      this.qsMaster.qs_master_refund!.readOnly = false;
      if (
        this.transType === Enums.TransType.CAN &&
        ((this.proposalStatus === Enums.ProposalStatus.Incomplete &&
          (this.identityRolesService.isMaker || this.isUnderwriter)) ||
          this.proposalStatus === Enums.ProposalStatus.Referred)
      ) {
        this.qsMaster.qs_master_endorse_endorsementReason!.required = true;
        this.qsMaster.qs_master_cancellation_masterpiece!.readOnly = false;
      }
      if (
        this.endorsementType === Enums.EndorsementType.ChangeOfPOI &&
        ((this.proposalStatus === Enums.ProposalStatus.Incomplete &&
          (this.identityRolesService.isMaker || this.isUnderwriter)) ||
          this.proposalStatus === Enums.ProposalStatus.Referred)
      ) {
        this.qsMaster.qs_master_effectiveDate!.readOnly = true;
        this.qsMaster.qs_master_poi_startDate!.readOnly = false;
      }
      if (
        this.endorsementType ===
          Enums.EndorsementType.ChangeOfAdditionalInsured &&
        ((this.proposalStatus === Enums.ProposalStatus.Incomplete &&
          (this.identityRolesService.isMaker || this.isUnderwriter)) ||
          this.proposalStatus === Enums.ProposalStatus.Referred)
      ) {
        this.qsMaster.qs_fire_interestedParties!.readOnly = false;
      }

      if (
        this.proposalStatus === Enums.ProposalStatus.Referred &&
        this.isBroker
      ) {
        this.qsMaster.qs_master_effectiveDate!.readOnly = true;
        this.qsMaster.qs_master_endorse_endorsementReason!.readOnly = true;
        this.qsMaster.qs_master_cancellation_masterpiece!.readOnly = true;
        this.qsMaster.qs_master_poi_startDate!.readOnly = true;
        this.qsMaster.qs_master_refund!.readOnly = true;
        this.qsMaster.qs_fire_interestedParties!.readOnly = true;
      }
    }

    if (
      this.refreshedProposalEntity.proposalReadOnly ||
      this.transType === Enums.TransType.CAN ||
      this.endorsementType === Enums.EndorsementType.LoanRedemption
    ) {
      this.qsMaster.qs_master_insuredAddress_building!.readOnly = true;
      this.qsMaster.qs_master_insuredAddress_lotunit!.readOnly = true;
    }
    if (
      this.endorsementType === Enums.EndorsementType.GeneralEndorsement &&
      this.transType === Enums.TransType.END &&
      ((this.proposalStatus === Enums.ProposalStatus.Incomplete &&
        (this.identityRolesService.isMaker || this.isUnderwriter)) ||
        (this.proposalStatus === Enums.ProposalStatus.Referred &&
          !this.identityRolesService.getIdentity().role.isOperationUnderwriter))
    ) {
      this.qsMaster.qs_master_endorse_endorsementReason!.required = false;
      this.qsMaster.qs_risk_insuredAddress_building!.readOnly = true;
      this.qsMaster.qs_risk_insuredAddress_lotunit!.readOnly = true;
      switch (this.productType) {
        case EnumSG.MortgageFireSgProduct.HDB:
        case EnumSG.MortgageFireSgProduct.CTHDB:
          this.qsMaster.qs_fire_occupied!.readOnly = true;
          this.qsMaster.qs_fire_replacement!.readOnly = true;
          this.qsMaster.qs_fire_building!.readOnly = true;
          this.qsMaster.qs_master_manualUnderwritting!.readOnly = true;
          this.qsMaster.qs_fire_interestedParties!.readOnly = true;
          break;
        case EnumSG.MortgageFireSgProduct.MIP:
        case EnumSG.MortgageFireSgProduct.PTE:
          this.qsMaster.qs_fire_occupied!.readOnly = false;
          this.qsMaster.qs_fire_replacement!.readOnly = true;
          this.qsMaster.qs_fire_building!.readOnly = true;
          this.qsMaster.qs_master_manualUnderwritting!.readOnly = true;
          this.qsMaster.qs_fire_interestedParties!.readOnly = true;
          if (
            this.qsMaster.qs_master_manualUnderwritting!.answer === "False" ||
            this.qsMaster.qs_master_manualUnderwritting!.answer === false
          ) {
            this.qsMaster.qs_master_manualUnderwritting!.readOnly = false;
          }
          break;
        case EnumSG.MortgageFireSgProduct.CTMFPTE:
        case EnumSG.MortgageFireSgProduct.CTMFCONDO:
          this.qsMaster.qs_fire_occupied!.readOnly = false;
          this.qsMaster.qs_fire_replacement!.readOnly = true;
          this.qsMaster.qs_fire_building!.readOnly = true;
          this.qsMaster.qs_master_manualUnderwritting!.readOnly = true;
          this.qsMaster.qs_fire_interestedParties!.readOnly = true;
          break;
        default:
        // do nothing
      }
    }

    if (
      this.endorsementType === Enums.EndorsementType.ChangeOfSumInsured &&
      ((this.proposalStatus === Enums.ProposalStatus.Incomplete &&
        (this.identityRolesService.isMaker || this.isUnderwriter)) ||
        (this.proposalStatus === Enums.ProposalStatus.Referred &&
          !this.identityRolesService.getIdentity().role.isOperationUnderwriter))
    ) {
      switch (this.productType) {
        case EnumSG.MortgageFireSgProduct.HDB:
        case EnumSG.MortgageFireSgProduct.CTHDB:
          this.qsMaster.qs_fire_occupied!.readOnly = false;
          this.qsMaster.qs_fire_occupied!.required = true;
          this.qsMaster.qs_fire_building!.readOnly = false;
          this.qsMaster.qs_fire_building!.required = true;
          if (
            this.qsMaster.qs_master_manualUnderwritting!.answer === "False" ||
            this.qsMaster.qs_master_manualUnderwritting!.answer === false
          ) {
            this.qsMaster.qs_master_manualUnderwritting!.readOnly = false;
          }
          break;
        case EnumSG.MortgageFireSgProduct.MIP:
        case EnumSG.MortgageFireSgProduct.PTE:
        case EnumSG.MortgageFireSgProduct.IBGMF:
        case EnumSG.MortgageFireSgProduct.CTMFPTE:
        case EnumSG.MortgageFireSgProduct.CTMFCONDO:
          this.qsMaster.qs_fire_replacement!.readOnly = false;
          this.qsMaster.qs_fire_replacement!.required = true;
          this.qsMaster.qs_fire_building!.readOnly = false;
          this.qsMaster.qs_fire_occupied!.readOnly = true;
          break;
        default:
          break;
      }

      if (
        this.proposalStatus === Enums.ProposalStatus.Referred &&
        this.isBroker
      ) {
        this.qsMaster.qs_fire_occupied!.readOnly = true;
        this.qsMaster.qs_fire_replacement!.readOnly = true;
        this.qsMaster.qs_fire_building!.readOnly = true;
        this.qsMaster.qs_master_manualUnderwritting!.readOnly = true;
      }
    }

    //2022-08-25 dagoh0: APACDM-363 - Handle fields required for change of plan type
    if (
      this.endorsementType === Enums.EndorsementType.ChangeOfPlanType &&
      this.proposalStatus === Enums.ProposalStatus.Incomplete &&
      (this.isUnderwriter ||
        this.identityRolesService.getIdentity().role.IsCbsOps ||
        this.identityRolesService.getIdentity().role.isOperationUnderwriter)
    ) {
      switch (this.productType) {
        case EnumSG.MortgageFireSgProduct.HDB:
        case EnumSG.MortgageFireSgProduct.PTE:
        case EnumSG.MortgageFireSgProduct.MIP:
          this.qsMaster.qs_fire_occupied!.readOnly = true;
          this.qsMaster.qs_master_endorse_endorsementReason!.readOnly = false;
          this.qsMaster.qs_master_refund!.readOnly = false;
          this.qsMaster.qs_master_planType!.readOnly = false;
          break;
        default:
          break;
      }
    }

    // If User role is isClaimant or ProductReadOnly, all the questions should be readOnly
    if (
      this.identityRolesService.isClaimant ||
      this.identityRolesService.isProductReadOnly
    ) {
      const questions = this.extractQuestionArray();
      questions.forEach((question) => {
        const q = proposalEntity.getQuestion(question.key);
        if (common.isDefined(q)) {
          question.readOnly = true;
        }
      });
    }
    // Enable Client Address and info endorsement for CBSOPS user
    const isChangeOfAddressOrClientInfo =
      this.endorsementType ===
        Enums.EndorsementType.ChangeOfCorrespondenceAddress ||
      this.endorsementType === Enums.EndorsementType.ChangeOfClientInfo;

    if (
      this.identityRolesService.IsCbsOps &&
      this.transType === Enums.TransType.END &&
      this.proposalStatus === Enums.ProposalStatus.Incomplete &&
      isChangeOfAddressOrClientInfo
    ) {
      this.qsMaster.qs_master_effectiveDate!.readOnly = false;
      this.qsMaster.qs_master_endorse_endorsementReason!.readOnly = false;
      this.qsMaster.qs_master_endorse_endorsementReason!.required = true;
      this.qsMaster.qs_master_refund!.readOnly = false;
    }

    // Enable client endorsement of IBG product FOR CBG OPS users
    const isIBGProducts =
      this.productType === EnumSG.MortgageFireSgProduct.IBGMAC ||
      this.productType === EnumSG.MortgageFireSgProduct.IBGMF;

    if (
      this.identityRolesService.IsCbsOps &&
      isIBGProducts &&
      this.transType === Enums.TransType.END &&
      this.endorsementType === Enums.EndorsementType.GeneralEndorsement &&
      this.proposalStatus === Enums.ProposalStatus.Incomplete
    ) {
      this.qsMaster.qs_master_effectiveDate!.readOnly = false;
      this.qsMaster.qs_master_endorse_endorsementReason!.readOnly = false;
      this.qsMaster.qs_master_endorse_endorsementReason!.required = true;
      this.qsMaster.qs_master_buPcCode!.readOnly = false;
      this.qsMaster.qs_master_bankReferNumber!.readOnly = false;
      this.qsMaster.qs_master_assetSerialNumber!.readOnly = false;
      this.qsMaster.qs_master_assetClassCode!.readOnly = false;
      this.qsMaster.qs_master_borrowerCIN!.readOnly = false;
      this.qsMaster.qs_master_insuredName!.readOnly = false;
      this.qsMaster.qs_master_dateOfBirthOrIncorporation!.readOnly = false;
      this.qsMaster.qs_master_insuredNo!.readOnly = false;
      this.qsMaster.qs_master_insuredNo2!.readOnly = false;
      this.qsMaster.qs_master_namesOtherInsured!.readOnly = false;
      this.qsMaster.qs_master_clientContactPerson!.readOnly = false;
      this.qsMaster.qs_master_clientContactPersonContactNo!.readOnly = false;
      this.qsMaster.qs_master_phoneNoOffice!.readOnly = false;
      this.qsMaster.qs_master_insuredAddress_lotunit!.readOnly = false;
      this.qsMaster.qs_master_insuredAddress_lotunit!.readOnly = false;
      this.qsMaster.qs_master_insuredAddress_building!.readOnly = false;
      this.qsMaster.qs_master_refund!.readOnly = false;
    }

    //Enabled client info endorsement for CS CBS SG User
    if (
      this.identityRolesService.IsCSCBGSG &&
      !isIBGProducts &&
      this.endorsementType === Enums.EndorsementType.ChangeOfClientInfo &&
      this.transType === Enums.TransType.END &&
      this.proposalStatus === Enums.ProposalStatus.Incomplete
    ) {
      this.qsMaster.qs_master_effectiveDate!.readOnly = true;
      this.qsMaster.qs_master_endorse_endorsementReason!.readOnly = false;
      this.qsMaster.qs_master_endorse_endorsementReason!.required = true;
      this.qsMaster.qs_master_refund!.readOnly = false;
    }

    if (
      this.identityRolesService.isOperationUnderwriter &&
      this.transType === Enums.TransType.CAN &&
      this.endorsementType ===
        Enums.EndorsementType.ChangeOfCorrespondenceAddress &&
      this.proposalStatus === Enums.ProposalStatus.Incomplete
    ) {
      this.qsMaster.qs_master_insuredAddress_lotunit!.readOnly = false;
      this.qsMaster.qs_master_insuredAddress_building!.readOnly = false;
      this.qsMaster.qs_master_endorse_endorsementReason!.readOnly = false;
      this.qsMaster.qs_master_effectiveDate!.readOnly = true;
      this.qsMaster.qs_master_refund!.readOnly = true;
    }

    if (
      this.transType === Enums.TransType.END &&
      this.proposalStatus === Enums.ProposalStatus.Incomplete &&
      (this.identityRolesService.isMaker || this.isUnderwriter)
    ) {
      this.qsMaster.qs_master_endorse_endorsementReason!.required = true;
    }

    // Cancellation adjustmentAmount and maximum adjust amount
    // Visibility Check
    if (
      this.transType === Enums.TransType.CAN &&
      this.endorsementType === Enums.EndorsementType.CancellationAdjustment
    ) {
      this.qsMaster.qs_master_cancellation_adjustmentAmount!.isVisible = true;
      this.qsMaster.qs_master_cancellation_maximumAdjustmentAmount!.isVisible =
        true;

      // Readonly Check
      if (
        this.proposalStatus === Enums.ProposalStatus.Incomplete &&
        this.isUnderwriter
      ) {
        // can edit only after incomplete and underwriter
        this.qsMaster.qs_master_cancellation_adjustmentAmount!.readOnly = false;
        this.qsMaster.qs_master_cancellation_maximumAdjustmentAmount!.readOnly =
          false;

        this.qsMaster.qs_master_cancellation_adjustmentAmount!.required = true;
      } else {
        this.qsMaster.qs_master_cancellation_adjustmentAmount!.readOnly = true;
        this.qsMaster.qs_master_cancellation_maximumAdjustmentAmount!.readOnly =
          true;

        this.qsMaster.qs_master_cancellation_adjustmentAmount!.required = false;
      }

      // Updating Min and Max value of adjustment amount depend on Maximum Adjustment amount
      var maximumAdjustmentAmount =
        this.qsMaster.qs_master_cancellation_maximumAdjustmentAmount;
      maximumAdjustmentAmount!.answer =
        maximumAdjustmentAmount!.answer === undefined ||
        isNaN(maximumAdjustmentAmount!.answer)
          ? 0
          : parseFloat(maximumAdjustmentAmount!.answer);

      var adjustmentAmount =
        this.qsMaster.qs_master_cancellation_adjustmentAmount;
      adjustmentAmount!.answer =
        adjustmentAmount!.answer === undefined ||
        isNaN(adjustmentAmount!.answer)
          ? 0
          : parseFloat(adjustmentAmount!.answer);
    } else {
      // Visibility Check
      this.qsMaster.qs_master_cancellation_adjustmentAmount!.isVisible = false;
      this.qsMaster.qs_master_cancellation_maximumAdjustmentAmount!.isVisible =
        false;

      this.qsMaster.qs_master_cancellation_adjustmentAmount!.required = false;
      this.qsMaster.qs_master_cancellation_maximumAdjustmentAmount!.required =
        false;
    }

    // Waive Minimum Premium Checkbox
    // Visibility Check
    if (
      this.transType === Enums.TransType.CAN &&
      this.auxiliary["DisplayMinimumPremiumWaived"]
    ) {
      this.qsMaster.qs_master_waiveMinimumPremium!.isVisible = true;

      // Disable Check
      if (this.proposalStatus === Enums.ProposalStatus.Incomplete) {
        if (!this.isUnderwriter) {
          this.qsMaster.qs_master_waiveMinimumPremium!.isDisabled = true;
          this.qsMaster.qs_master_waiveMinimumPremium!.isVisible = false;
        } else {
          this.qsMaster.qs_master_waiveMinimumPremium!.isDisabled =
            this.auxiliary["FirstCancellationWaiveMinimumPremium"];
          this.qsMaster.qs_master_waiveMinimumPremium!.isVisible = true;
        }
      } else {
        /* for accepted scenario */
        if (!this.isUnderwriter) {
          this.qsMaster.qs_master_waiveMinimumPremium!.isVisible = false;
        } else {
          this.qsMaster.qs_master_waiveMinimumPremium!.isVisible = true;
        }

        this.qsMaster.qs_master_waiveMinimumPremium!.isDisabled = true;
      }
    } else {
      // Visibility Check
      this.qsMaster.qs_master_waiveMinimumPremium!.isVisible = false;
    }

    this.refreshCustomQuestionsReadOnlyForDeliveryMethod(proposalEntity);
  };

  refreshCustomQuestionsReadOnlyForDeliveryMethod(
    proposalEntity: ProposalEntity
  ) {
    if (
      this.transType === Enums.TransType.END &&
      this.endorsementType === Enums.EndorsementType.GeneralEndorsement &&
      this.proposalStatus === Enums.ProposalStatus.Incomplete
    ) {
      switch (this.productType) {
        case EnumSG.MortgageFireSgProduct.HDB:
        case EnumSG.MortgageFireSgProduct.MIP:
        case EnumSG.MortgageFireSgProduct.PTE:
        case EnumSG.MortgageFireSgProduct.CTHDB:
        case EnumSG.MortgageFireSgProduct.CTMFPTE:
        case EnumSG.MortgageFireSgProduct.CTMFCONDO:
          this.qsMaster.qs_master_preferredDeliveryMethod!.readOnly = true;
          break;
        case EnumSG.MortgageFireSgProduct.IBGMF:
        case EnumSG.MortgageFireSgProduct.IBGMAC:
          // this.qsMaster.qs_master_preferredDeliveryMethod.readOnly = true;
          // this.qsMaster.qs_master_mobileNumber.readOnly=true;
          // this.qsMaster.qs_master_emailID.readOnly=true;
          break;
      }
    }
  }
  refreshPotentiallyChangedQuestions(proposalEntity: ProposalEntity) {
    ExceptionManager.argumentNullGuard(proposalEntity, "proposalEntity");
    ExceptionManager.argumentNullGuard(
      proposalEntity.questions,
      "proposalEntity.questions"
    );

    this.qsMaster.questions.forEach((question) => {
      const q = proposalEntity.getQuestion(question.key);
      if (q && common.isDefined(q)) {
        switch (question.key) {
          case "qs_master_effectiveDate":
            this.qsMaster.qs_master_effectiveDate!.answer = q.answer;
            break;
          case "qs_master_endorse_endorsementReason":
            this.qsMaster.qs_master_endorse_endorsementReason!.answer =
              q.answer;
            break;
          case "qs_master_refund":
            this.qsMaster.qs_master_refund!.answer = q.answer;
            break;
          case "qs_fire_occupied":
            this.qsMaster.qs_fire_occupied!.answer = q.answer;
            break;
          case "qs_master_manualUnderwritting":
            this.qsMaster.qs_master_manualUnderwritting!.answer = q.answer;
            break;
          case "qs_master_insuredCountry":
            if (
              this.qsMaster.qs_master_insuredCountry!.answer === null ||
              this.qsMaster.qs_master_insuredCountry!.answer === ""
            ) {
              this.qsMaster.qs_master_insuredCountry!.answer = "SG";
            }
            break;
          case "qs_fire_freeInsuranceFirstYear":
            // IBG
            if (
              this.productType === EnumSG.MortgageFireSgProduct.IBGMF ||
              this.productType === EnumSG.MortgageFireSgProduct.IBGMAC
            ) {
              this.qsMaster.qs_fire_freeInsuranceFirstYear!.answer = q.answer;
            }

            break;
          case "qs_fire_freeInsuranceNoYear":
            ////Chirag: 28-12-2018 Free Year Change For CBG Prodcut
            // IBG
            // if (this.productType === EnumSG.MortgageFireSgProduct.IBGMF
            //   || this.productType === EnumSG.MortgageFireSgProduct.IBGMAC) {
            this.qsMaster.qs_fire_freeInsuranceNoYear!.answer = q.answer;
            //}
            break;
          case "qs_master_masterPolicyNumber":
            // PTE and MIP
            if (
              this.productType === EnumSG.MortgageFireSgProduct.PTE ||
              this.productType === EnumSG.MortgageFireSgProduct.MIP
            ) {
              this.qsMaster.qs_master_masterPolicyNumber!.answer = q.answer;
            }

            break;
          case "qs_master_poi_startDate":
            if (this.transType === Enums.TransType.REN) {
              this.qsMaster.qs_master_poi_startDate!.answer = q.answer;
            }
            break;
          case "qs_master_poi_endDate":
            if (this.transType === Enums.TransType.REN) {
              this.qsMaster.qs_master_poi_endDate!.answer = q.answer;
            }
            break;
          case "qs_master_cancellation_maximumAdjustmentAmount":
            this.qsMaster.qs_master_cancellation_maximumAdjustmentAmount!.answer =
              q.answer;
            break;
          case "qs_master_lstDetails":
            this.qsMaster.qs_master_lstDetails!.answer = q.answer;
            break;
          case "qs_master_lst":
            this.qsMaster.qs_master_lst!.answer = q.answer;
            break;
          case "qs_master_planType":
            this.qsMaster.qs_master_planType!.answer = q.answer;
            break;
          case "qs_master_discountCode":
            this.qsMaster.qs_master_discountCode!.answer = q.answer;
            break;
          case "qs_master_customDiscountCode":
            this.qsMaster.qs_master_customDiscountCode!.answer = q.answer;
            break;
          default:
        }
      }
    });
    this.qsPremiumSummary.questions.forEach((question) => {
      const q = proposalEntity.getQuestion(question.key);
      if (common.isDefined(q)) {
        switch (question.key) {
          case "qs_master_brokerCommission":
            this.qsPremiumSummary.qs_master_brokerCommission.answer = q!.answer;
            break;

          default:
        }
      }
    });
  }

  refreshQuestions(proposalEntity: ProposalEntity) {
    ExceptionManager.argumentNullGuard(proposalEntity, "proposalEntity");
    ExceptionManager.argumentNullGuard(
      proposalEntity.questions,
      "proposalEntity.questions"
    );

    this.refreshedProposalEntity = proposalEntity;
    this.proposalId = proposalEntity.proposalId;
    this.qsMaster.refreshQuestions(proposalEntity);
    this.qsPremiumSummary.refreshQuestions(proposalEntity);

    // it is always one children
    if (
      common.isDefined(proposalEntity.children) &&
      /* While creating new proposal, back end is returning an children array with zero item, therefore, check for child length */
      proposalEntity.children &&
      proposalEntity.children!.length! > 0 &&
      common.isDefined(this.children) &&
      this.children.length > 0
    ) {
      this.children[0].refreshQuestions(proposalEntity.children[0]);
    }
  }

  refreshPremiumSummary(proposalEntity: ProposalEntity) {
    ExceptionManager.argumentNullGuard(proposalEntity, "proposalEntity");

    /** Refresh the proposalId and entity to pass back to back-end */
    this.refreshedProposalEntity = proposalEntity;
    this.proposalId = proposalEntity.proposalId;

    this.IsCancellationAdjustment =
      this.endorsementType == Enums.EndorsementType.CancellationAdjustment;

    // TODO: refresh premium summary
  }

  refreshValidationMessage(proposalEntity: ProposalEntity) {
    ExceptionManager.argumentNullGuard(proposalEntity, "proposalEntity");

    /** Refresh the proposalId and entity to pass back to back-end */
    this.validationMessage = proposalEntity.validationsMessages;
    this.proposalId = proposalEntity.proposalId;
  }

  extractQuestionArray(): QuestionEntity[] {
    const questions: QuestionEntity[] = [];

    this.qsMaster.questions.forEach((q) => {
      if (common.isDefined(this.refreshedProposalEntity.getQuestion(q.key))) {
        questions.push(q);
      }
    });

    this.qsPremiumSummary.questions.forEach((q) => {
      if (common.isDefined(this.refreshedProposalEntity.getQuestion(q.key))) {
        questions.push(q);
      }
    });

    return questions;
  }

  createOneChild(): MortgageFireSingaporeProposalLocation {
    const newChild = this.createEmptyLocation();
    this.children.push(newChild);

    return newChild;
  }

  getChild(proposalId: GUID): MortgageFireSingaporeProposalLocation {
    const found = proposalHelper.searchChildren(this.children, proposalId);
    return found as MortgageFireSingaporeProposalLocation;
  }

  private createEmptyLocation(): MortgageFireSingaporeProposalLocation {
    const location = new MortgageFireSingaporeProposalLocation(
      this.productId,
      this.identityRolesService
    );
    return location;
  }
}
